<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Dedication-rw auto-rw page-open-left-rw" epub:type="frontmatter dedication">
<p class="ded"><a id="page-v"></a>To my mother, Natella Carper, 1904–2000, an inspiring spirit who lived ninety-five years without dementia and a final year with probable vascular dementia</p>
<p class="ded1">And to my sisters, Joan Hickson and Judy Stevens, with whom I share a single copy of the ApoE4 Alzheimer’s susceptibility gene</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?537393f4